import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'durationToString'
})
export class DurationToStringPipe implements PipeTransform {

  transform(timeInMinutes: number): string {
    let ret = '';

    if (timeInMinutes !== null) {
      // NB : Date is in milliseconds
      const date = new Date(timeInMinutes * 60 * 1000);

      const hours = date.getUTCHours();
      const hh = '' + hours;

      const minutes = date.getUTCMinutes();
      const mm = (hours > 0 && minutes < 10) ? '0' + minutes : '' + minutes;

      if (hours > 0) {
        ret = hh + 'h';
      }
      if (minutes > 0) {
        ret += mm + ' min';
      }

      return ret;
    }
  }
}
